import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import Axios from 'axios';
import moment from 'moment';
// import { Services } from './../../Services';
import {Services} from '../../Services';
import ClientesList from '../../../../../services/storageClient.js';
const clientSave = new ClientesList();





/*=============================================
=            Catalogs Trends By Year          =
=============================================*/

function CatYears(props) {
  const [CatalogYears, setCatalogYears] = React.useState([]);
  // const [CatalogModele, setCatalogModele] = React.useState([]);
  const [setCatalogModele] = React.useState([]);

  const [Module, setModule] = React.useState('');
  const [date, setDate] = React.useState(moment(new Date()).format('YYYY'));
  const GetCatalog = React.useCallback(async () => {
    try {
      let data = {
        customer: clientSave.getAuthentication('client')
      }
      let CatYears = await Axios.post(`${Services.GET_DASHBOARD_CATYEARS.path}dashboard/catyears`, data);
      setCatalogYears(CatYears.data.data.year ? CatYears.data.data.year : []);
      setCatalogModele(CatYears.data.data.module ? CatYears.data.data.module : []);
      setDate(CatYears.data.data.year.length > 0 ? CatYears.data.data.year[0].value : '');
      setModule(CatYears.data.data.module.length > 0 ? CatYears.data.data.module[0].value : '');
      props.onChangeYear(CatYears.data.data.year.length > 0 ? CatYears.data.data.year[0].value : '', CatYears.data.data.module.length > 0 ? CatYears.data.data.module[0].value : '');
    } catch (error) {
      console.error(error);
    }
  },[]);

  function onChangeDate(evt, data) {
    setDate(data.value);
    props.onChangeYear(data.value, Module);
  };
  // function onChangeModule(evt, data) {
  //   setModule(data.value);
  //   props.onChangeYear(date, data.value);
  // };

  React.useEffect(() => {
    GetCatalog();
  }, [GetCatalog]);

  return (
    <>
      {/* <div style={{marginLeft:'-101px'}}>
       <Row>
       <Dropdown
        className="catalog-year-container"
        text={Module}
        scrolling
        placeholder='Tendencia de Ingresos'
        // fluid
        // selection
        onChange={onChangeModule}
        defaultValue={Module}
        options={CatalogModele}
      />
            <button style={{ fontSize: '11px', marginLeft: '-17px',marginTop:'10px'}}>▼</button>
       </Row>
    </div> */}
      <div>
        <Dropdown
          className="catalog-year-container"
          text={date}
          scrolling
          onChange={onChangeDate}
          defaultValue={date}
          options={CatalogYears}>
        </Dropdown>
        {/* <button>▼</button> */}
      </div>
    </>
  );
}



export default CatYears;